'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { ActionButton } from './ActionButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OpenThreadButton = ({
  isOpeningThread,
  onClick,
  className,
  disabled = false
}) => {
  if (isOpeningThread) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      size: "extra-small",
      use: "tertiary-light"
    });
  }
  return /*#__PURE__*/_jsxs(ActionButton, {
    onClick: onClick,
    disabled: disabled,
    className: className,
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "redo",
      size: 18
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-thread-view.thread-toolbar.openThreadButton"
    })]
  });
};
OpenThreadButton.displayName = 'OpenThreadButton';
OpenThreadButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  isOpeningThread: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};
export default OpenThreadButton;